import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'showOption'];

  connect() {
    this.checkDisplayCondition();
  }

  changeOptionHandler() {
    this.checkDisplayCondition();
  }

  checkDisplayCondition() {
    if (this.showOptionTargets.some((target) => target.checked)) {
      this.showField();
    } else {
      this.hideField();
    }
  }

  showField() {
    this.fieldTarget.classList.remove('hidden');
  }

  hideField() {
    this.fieldTarget.classList.add('hidden');
  }
}
